module.exports = __webpack_public_path__ + "img/service-bg.dec54077.png";